/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrackets = createReactComponent("outline", "brackets", "IconBrackets", [["path", { "d": "M8 4h-3v16h3", "key": "svg-0" }], ["path", { "d": "M16 4h3v16h-3", "key": "svg-1" }]]);

export { IconBrackets as default };
//# sourceMappingURL=IconBrackets.mjs.map
